<template>
  <div id="app">
    <app-header/>
    <section class="container">
      <app-grid/>
      <div id="sidebar">
        <h3>{{ $t("form.title") }}</h3>
        <app-form/>
        <app-code/>
      </div>
    </section>
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppGrid from "./components/AppGrid.vue";
import AppForm from "./components/AppForm.vue";
import AppCode from "./components/AppCode.vue";

export default {
  components: {
    AppHeader,
    AppGrid,
    AppForm,
    AppCode
  },
  created() {
    this.$store.commit("initialArrIndex", window.location.search);
  }
};
</script>

<style lang="scss">
#app {
  margin: 0;
}

.container {
  display: flex;
  padding: 0 2em;
  gap: 3em;
  height: 100%;
}
#sidebar {
  width: 480px;
  min-width: 480px; 
}

@media screen and (max-width: 1000px) {
  .container {
    flex-direction: column;
  }
  #sidebar {
    width: 100%;
    min-width: auto; 
    margin-top: 100px;
  }
}
</style>
